import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, AddDiscountClickBiEvent } from '@wix/da-bi/pkg/events';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import SellerDiscountModal from '../../../../shop/SellerDiscounts/SellerDiscountModal';

interface Props {}

const CreateDiscountGhostButton: FC<Props> = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <GhostButton
        variant="main"
        size="medium"
        icon={AddIcon}
        onClick={() => setIsModalOpen(true)}
        biData={BiData<AddDiscountClickBiEvent>({
          evid: 450,
          sectionname: 'header',
        })}
      >
        {t('studio.header.tabs.discounts.addDiscount')}
      </GhostButton>
      {isModalOpen && (
        <SellerDiscountModal onRequestClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};
CreateDiscountGhostButton.displayName = 'CreateDiscountGhostButton';

export default CreateDiscountGhostButton;
